module.exports = [{"name":"Pet first aid kit","quantity":1,"perishable":false,"shareable":true},{"name":"Medication for your pet (check with you vet before storing)","quantity":1,"perishable":true,"shareable":true},{"name":"Pet collar, leash, and toys","quantity":1,"perishable":false,"shareable":true},{"name":"Cage or Kennel","quantity":1,"perishable":false,"shareable":true},{"name":"Pet food","quantity":1,"perishable":false,"shareable":true},{"name":"Cat litter","quantity":1,"perishable":false,"shareable":true}]


//////////////////
// WEBPACK FOOTER
// ./src/basekits/addons/pets.json
// module id = 294
// module chunks = 0